define('lq/html',[
    'jquery',
    'HtmlSanitizer'
], function ($, HtmlSanitizer) {

    // WHY can't use _.escape() and _.unescape() here, because that one
    // assumes ' is replaced with &#27; while the backend actually replaces it with &#39;

    var $htmStripper = $('<div />');

    return {
        escape: function(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/\u00A0/g, '&#160;')
                .replace(/>/g, '&gt;');
        },
        unescape: function(text) {
            return String(text)
                .replace(/&amp;/g, '&')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, '\'')
                .replace(/&#27;/g, '\'')
                .replace(/&#160;/g, '\u00A0')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>');
        },
        strip: function (text) {
            if (!text) return text;
            return $htmStripper.html(text).text();
        },
        sanitize: function (text) {
            if(!text) return text;
            return HtmlSanitizer.SanitizeHtml(text);
        },
        allowAttribute: function (attribute) {
            HtmlSanitizer.AllowedAttributes[attribute.trim().toLowerCase()] = true;
        },
    };

});
